<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>

        <div class="content-blocks">

            <section class="page-header-section full-view-header full-height">
                <div class="image-block" style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/06/Page-Acceuil-2025.png')"></div>
            </section>

            <section class="vendre-and-acheter-section panel" id="vendre-and-acheter-section">

                <div class="list-block">
                    <div class="list">
                        <div class="bg"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/07/Capture-decran-2021-04-19-a-13.36.08.jpg')">
                        </div>
                        <h2 class="h2">Vendre mon véhicule</h2>
                        <p>Estimez votre véhicule rapidement et gratuitement</p>
                        <a :href="route('minisite.vendre')" aria-label="Vendre mon véhicule"></a>
                    </div>
                    <div class="list">
                        <div class="bg"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/02/trouvez_votre_voiture-min.png')">
                        </div>
                        <h2 class="h2">Acheter un véhicule</h2>
                        <p>Choisissez votre prochain compagnon de route </p>
                        <a :href="route('minisite.acheter')" aria-label="Acheter un véhicule"></a>
                    </div>

                    <div class="list">
                        <div class="bg"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/02/trouvez_votre_voiture-min.png')">
                        </div>
                        <h2 class="h2">Je souhaite devenir franchisé</h2>
                        <p>Devenir franchisé</p>
                        <a :href="route('minisite.acheter')" aria-label="Devenir Franchisé"></a>
                    </div>
                </div>
            </section>


            <section class="news-block-by-ewigo-carrousel-section ">
                <div class="container">
                    <h2 class="h2 center anim fade up">Nos dernières annonces</h2>
                    <div class="row posts-list-grid observatory-grid">

                        <template v-for="(item, index) in ads" :key="item.id">

                            <ad :ad="item"></ad>
                        </template>


                    </div>

                    <p style="text-align: center;margin: 20px;"><a :href="route('minisite.acheter')"
                                                                   class="btn primary-btn anim fade left in-view">Voir
                        tous nos véhicules</a></p>

                </div>
            </section>


            <section class="why-us-section">
                <div class="why-choose-us">
                    <div class="content-block">
                        <div class="header-block">
                            <h2 class="h3 anim fade up">Pourquoi choisir Ewigo ?</h2>
                                <img class="labels-logo-1" src="https://www.ewigo.com/wp-content/uploads/2025/02/MFDA-2025.png" alt="Meilleur franchise de l'année">
                                <img class="labels-logo-2" src="https://www.ewigo.com/wp-content/uploads/2025/02/MCDMA-2025.png" alt="Meilleure chaîne magasin 2025">                        </div>

                        <div class="list-block row">
                            <div class="list col-md-4">
                                <div class="image-block">
                                    <lottie-player
                                        src="/img/compoCadenas.json"
                                        background="transparent" speed="1" style="width: 100%;max-width:100%" loop
                                        autoplay></lottie-player>
                                </div>
                                <div class="content">
                                    <h3 class="h3 anim slide-right">Sécurité</h3>
                                    <p class="anim slide-right">De l'origine à l'entretien jusqu'au paiement du
                                        véhicule, nous nous assurons que tout soit parfait.</p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="image-block">
                                    <lottie-player
                                        src="/img/compoMain.json"
                                        background="transparent" speed="1" style="width: 100%;max-width:100%" loop
                                        autoplay></lottie-player>
                                </div>
                                <div class="content">
                                    <h3 class="h3 anim slide-right">Confiance</h3>
                                    <p class="anim slide-right">Un ambassadeur Ewigo s'occupe de tout afin que vous
                                        vendiez ou achetiez dans les meilleures conditions.</p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="image-block">
                                    <lottie-player
                                        src="/img/compoPerso.json"
                                        background="transparent" speed="1" style="width: 100%;max-width:100%" loop
                                        autoplay></lottie-player>
                                </div>
                                <div class="content">
                                    <h3 class="h3 anim slide-right">Satisfaction</h3>
                                    <p class="anim slide-right">Un objectif : Vous satisfaire au mieux . 4,7/ 5 retour
                                        moyen de nos clients sur plus de 5000 avis Google.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="testimonial-section">
                    <div class="content-block">
                        <h2 class="h3 white anim fade up">Ils nous ont fait confiance</h2>
                        <div class="testimonial-block">
                            <template v-if="showFakeReviews === false && reviews.length > 0">
                                <div class="slide" v-for="(review, index) in reviews" :key="`review-${review.id}-${index}`">
                                    <div class="testimonial slide anim fade left">
                                        <div class="content">
                                            <div class="author">
                                                <div class="headshot"
                                                     style="background-image: url();">
                                                </div>
                                                <p class="title bold">{{review.author_name}}</p>
                                                <div class="rating"></div>
                                            </div>
                                            <p class="message">{{review.text.substring(0,200)+"..."}}</p>
                                            <p class="designation">Agence {{agency.name}}</p>
                                            <p class="time">{{review.relative_time_description}}</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="showFakeReviews">
                                <div v-for="n in 5" class="slide" :key="`review-${n}`">
                                    <div class="testimonial slide anim fade left">
                                        <div class="content">
                                            <div class="author">
                                                <div class="headshot"
                                                     style="background-image: url();">
                                                </div>
                                                <p class="title bold">Benoit T.</p>
                                                <div class="rating"></div>
                                            </div>
                                            <p class="message">Nos inspecteurs automobiles effectuent 100 points de
                                                contrôle, un essai routier et l’historique est vérifié sur chacun de nos
                                                véhicules.</p>
                                            <p class="designation">Agence de La Rochelle</p>
                                            <p class="time">Il y a 3 semaines</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>


            <section class="page-header-section full-view-header vendre-header meilleure-solution no-margin">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/07/Mask-Group-47-e1631285247735-1.jpg')">
                </div>
                <div class="container">
                    <div class="content">
                        <h1 class="h1 white anim fade right">Choisissez la meilleure solution</h1>
                        <h4 class="h4 white anim fade right delay1">et estimez votre véhicule gratuitement</h4>
                    </div>
                    <div class="search-block anim fade up delay2">

                        <form :action="route('minisite.landing-page-reprise-depot')" method="get" class="form-block">
                            <div class="input-box">
                                <input type="text" placeholder="Numéro d’immatriculation " name="registration">
                            </div>
                            <div class="submit-button">
                                <input type="submit">
                            </div>
                        </form>
                    </div>
                </div>

            </section>


            <section class="equipe_ecoute">
                <div class="franchise">
                    <h3>Notre équipe à votre écoute</h3>
                    <template v-for="(member, index) in members" :key="`boss-${member.id}-${index}`">
                        <div class="boss" v-if="member.profile_photo_url && member.role == 'owner'">
                            <img :src="`${member.profile_photo_url}`" alt="Employé Ewigo">
                            <div class="infos">
                                <p class="h4">{{ member.first_name }} {{ member.last_name }}</p>
                                <p class="status">{{ member.job }}</p>
                            </div>
                        </div>
                    </template>
                    <p class="content" v-html="agency.content_website">

                    </p>
                </div>
                <div class="team">
                    <template v-for="(member, index) in members" :key="`member-${member.id}-${index}`">
                        <div class="member" v-if="member.profile_photo_url && member.role != 'owner'">
                            <img :src="`${member.profile_photo_url}`" alt="Employé Ewigo">
                            <p class="name">{{ member.first_name }} {{ member.last_name }}</p>
                            <p class="pole">{{ member.job }}</p>
                        </div>
                    </template>
                </div>

            </section>


            <section class="news-section">
                <h2 class="h2 white">Nos Actualités</h2>
                <p class="white">Découvrez l’Observatoire Ewigo, répertoire d’articles sur le monde auto et de la
                    franchise.</p>
                <div class="list-block row">
                    <div class="list">
                        <div class="image-block"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/07/Mockup-obs-carre.jpg');">
                        </div>
                        <a href="#">
                            <h3 class="h3 white anim fade right">L’observatoire Ewigo</h3>
                        </a>
                    </div>
                    <div class="list">
                        <div class="image-block"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/07/mockup-actualite.jpg');">
                        </div>
                        <a href="#">
                            <h3 class="h3 white anim fade right">Nos dernières actualités</h3>
                        </a>
                    </div>
                    <div class="list">
                        <div class="image-block"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/07/les-medias-parlent-de-nous.jpg');">
                        </div>
                        <a href="#">
                            <h3 class="h3 white anim fade right">Les médias parlent de nous</h3>
                        </a>
                    </div>
                </div>
            </section>


            <section class="newsletter-section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <h2 class="h2 white anim fade up">Newsletter</h2>
                            <p class="white title anim fade up delay1">Suivez toutes nos actualités en vous abonnant à
                                la newsletter</p>
                            <div class="anim fade up delay2">
                                <div role="form" class="wpcf7" id="form_newsletter" lang="en-US" dir="ltr">
                                    <div class="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form method="post"
                                          @submit.prevent="newsletter"
                                          class="wpcf7-form init" novalidate="novalidate" data-status="init">
                                        <div v-if="!successNewsletter" class="form-newsletter">
                                            <div class="email-box">
                                                <span class="wpcf7-form-control-wrap your-email"><input type="email"
                                                                                                        size="40"
                                                                                                        v-model="form.email"
                                                                                                        placeholder="Email"
                                                                                                        class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                                                                                        aria-required="true"
                                                                                                        aria-invalid="false"/></span>
                                                <div v-if="errors.email" class="wpcf7-not-valid-tip">{{
                                                        errors.email
                                                    }}
                                                </div>
                                            </div>
                                            <div class="submit-button">
                                                <input type="submit" value="Submit"
                                                       class="wpcf7-form-control has-spinner wpcf7-submit"
                                                       id="form_newsletter_submit"
                                                />
                                            </div>
                                        </div>
                                        <div v-if="successNewsletter" class="wpcf7-not-valid-tip"
                                             style="color: #46b450;">Inscription à la newsletter effectuée avec succès
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </section>

        </div>

        <div class="header-sliders home">
            <div class="slider">
                <span><img src="https://www.ewigo.com/wp-content/uploads/2021/09/appel-telephonique.png"
                           alt=""></span>
                <a :href="'tel:' + agency.phone" id="home_agency_phone">{{ agency.phone }}</a>
            </div>
        </div>
    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
import Layout from './Ads/Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from "@/Pages/Partials/Footer"
import Header from "@/Pages/Partials/Header"
import Ad from "@/Pages/Partials/Ad"

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        Ad,
    },
    props: {
        agency: Object,
        title: String,
        description: String,
        bg_img: String,
        body_class: String,
        ads: Object,
        members: Object,
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: null,
            }),
            successNewsletter: false,
            reviews: [],
            showFakeReviews: false,
        }
    },
    methods: {
        getReviews() {
            axios.get(`${this.$page.props.ewigoExtranetUrl}/api/get/reviews/${this.agency.id_ewigo}`)
                .then((response) => {
                    this.showFakeReviews = false;
                    this.reviews = response.data.data;
                    $(document).ready(function () {
                        $(".testimonial-section .testimonial-block").slick('refresh');
                    });
                })
                .catch((error) => {
                    if (error) {
                        this.showFakeReviews = true;
                        this.reviews = [];
                        $(document).ready(function () {
                            $(".testimonial-section .testimonial-block").slick('refresh');
                        });
                    }
                })
        },
        newsletter() {
            this.form.post(route('minisite.newsletter'), {
                preserveScroll: true,
                onSuccess: (response) => {
                    this.successNewsletter = true
                },
                onError: (e) => {
                    console.log(e)
                }
            })
        },
    },
    created() {
        this.getReviews();
    },
    mounted() {

        document.body.classList.add(this.body_class.split(' '));

        let oldValueScroll = 0;
        let newValueScroll = 0;
        const elToGoPosition = document.getElementById('vendre-and-acheter-section').getBoundingClientRect().top + window.pageYOffset;
        const headerHeight = document.getElementById('masthead').getBoundingClientRect().height;
        if (window.innerWidth > 991) {
            addEventListener('scroll', (e) => {
                newValueScroll = window.scrollY;
                if ((newValueScroll - oldValueScroll) > 30 && oldValueScroll == 0) {
                    window.scrollTo({
                        top: elToGoPosition - headerHeight,
                        behavior: 'smooth'
                    });
                    oldValueScroll = newValueScroll;
                }
            })
        }
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    },
}
</script>

<style scoped lang="scss">
.header-sliders {
    bottom: 185px;
}

.vendre-and-acheter-section .list-block .list a {
    z-index: 1000;
}

.boss {
    img {
        max-width: 214px;
        border-radius: 214px;
    }
}

.team {
    padding: 0 20px;

    .member {
        padding: 20px;

        img {
            border-radius: 195px;
            width: 128px;
            height: 128px;
        }
    }
}

.list h2 {
    font-weight: 500 !important;
}

.news-block-by-ewigo-carrousel-section h2, .testimonial-section h2 {
    font-size: 2.3rem;
}

@media screen and (max-width: 768px) {
    .equipe_ecoute .boss {
        flex-direction: column;
    }
    .news-section .list-block .list a {
        width: 90%;
    }
}

.content-blocks {
    scroll-snap-type: y mandatory;
}

.vendre-and-acheter-section, .page-header-section {
    scroll-snap-align: start;
}

.wpcf7-success {
    background: rgba(70, 180, 80, 0.1490196078);
    border: 0;
    padding: 20px;
    border-radius: 10px;
    color: #46b450;
    font-size: 1rem;
    font-family: "Poppins";
    text-align: left;
    margin: 0;
    margin-top: 10px;
    max-width: 100%;
}


.wpcf7-not-valid-tip {
    margin-top: 25px;
}
</style>
